import { useState } from "react";

interface Props {
  className?: string;
  enableHover?: boolean;
  hoverDuration?: number;
}

export const _FooterFacebookIcon = ({
  className = "",
  enableHover = true,
  hoverDuration = 200
}: Props): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a 
      href="https://www.facebook.com/foreveryoursweddingfilms"
      target="_blank"
      rel="noopener noreferrer"
      className={`relative w-[42px] h-[42px] ${className}`}
      onMouseEnter={() => enableHover && window.innerWidth >= 768 && setIsHovered(true)}
      onMouseLeave={() => enableHover && window.innerWidth >= 768 && setIsHovered(false)}
    >
      {/* Default state */}
      <svg
        className={`absolute inset-0 transition-opacity duration-${hoverDuration}`}
        style={{ opacity: isHovered && window.innerWidth >= 768 ? 0 : 1 }}
        fill="none"
        height="43"
        viewBox="0 0 43 43"
        width="43"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21.2969" cy="21.6641" r="21" stroke="var(--fy-grey)" strokeWidth="1" fill="none" />
        <path
          d="M22.8291 30.0715V22.5903H25.3425L25.7166 19.6765H22.8291V17.8062C22.8291 16.9597 23.0653 16.3887 24.2728 16.3887H25.815V13.7637C25.067 13.69 24.3156 13.6571 23.5641 13.6653C21.3394 13.6653 19.8103 15.0237 19.8103 17.5175V19.67H17.2969V22.5903H19.8169V30.0715H22.8291Z"
          fill="#657D84"
        />
      </svg>

      {/* Hover state */}
      <svg
        className={`absolute inset-0 transition-opacity duration-${hoverDuration}`}
        style={{ opacity: isHovered && window.innerWidth >= 768 ? 1 : 0 }}
        fill="none"
        height="43"
        viewBox="0 0 43 43"
        width="43"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21.2969" cy="21.6641" r="21" fill="var(--fy-grey)" />
        <path
          d="M22.8291 30.0715V22.5903H25.3425L25.7166 19.6765H22.8291V17.8062C22.8291 16.9597 23.0653 16.3887 24.2728 16.3887H25.815V13.7637C25.067 13.69 24.3156 13.6571 23.5641 13.6653C21.3394 13.6653 19.8103 15.0237 19.8103 17.5175V19.67H17.2969V22.5903H19.8169V30.0715H22.8291Z"
          fill="var(--fy-blue)"
        />
      </svg>
    </a>
  );
}; 